module.exports = __webpack_public_path__ + "static/img/Report3DImg5.50b297cf.png";